const methods = {
    updateFromRd() {
        this.loading = true;
        setTimeout(() => {
            this.$root.$emit('showModalUpdateFromRd', false);
            this.$root.$emit('showUpdateResume', {
                // TODO: Eliminar esto cuando se tenga acceso al servicio de RD
                valued_operations: Math.round(Math.random() * 10),
                updated_operations: Math.round(Math.random() * 10),
                mismatches: Math.round(Math.random() * 10),
                imported: Math.round(Math.random() * 10)
            });
            this.loading = false;
        }, 3000);
    }
};

export default methods;
